import React, { useState } from 'react'
import { Sparkles, Loader2 } from 'lucide-react'
import KaTeXRenderer from '../common/KaTeXRenderer'
import StudentAIPlanModal from './StudentAIPlanModal'
import { studentAi, StudentAIError } from '../../services/studentAi'

// "Nhận xét bài làm bằng AI" cho MỘT lượt làm đề PMaker (cần Gói AI học tập; xem lại miễn phí).
const StudentAIReviewPanel: React.FC<{ attemptId?: string }> = ({ attemptId }) => {
  const [content, setContent] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [planOpen, setPlanOpen] = useState(false)
  const [reason, setReason] = useState('')

  if (!attemptId) return null

  const run = async () => {
    setBusy(true); setErr('')
    try {
      const r = await studentAi.review(attemptId)
      setContent(r.content)
    } catch (e) {
      const ex = e as StudentAIError
      if (ex.status === 402) { setReason(ex.message); setPlanOpen(true) }
      else setErr(ex.message || 'Chưa nhận xét được, thử lại sau.')
    } finally { setBusy(false) }
  }

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/60 p-4 mb-6">
      <div className="flex flex-wrap items-center gap-2">
        <Sparkles className="w-5 h-5 text-amber-500" />
        <h3 className="font-bold text-slate-800 flex-1">Nhận xét bài làm bằng AI</h3>
        {!content && (
          <button onClick={run} disabled={busy}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-amber-500 text-white text-sm font-bold hover:bg-amber-600 disabled:opacity-50">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />} {busy ? 'AI đang đọc bài…' : 'Nhận xét'}
          </button>
        )}
      </div>
      {!content && !err && <p className="text-xs text-slate-500 mt-1">Tổng quan, điểm mạnh, lỗ hổng kiến thức và kế hoạch ôn tập (Gói AI học tập).</p>}
      {err && <p className="text-sm text-rose-600 mt-2">{err}</p>}
      {content && <div className="mt-3 text-slate-800 leading-relaxed"><KaTeXRenderer content={content} /></div>}
      <StudentAIPlanModal open={planOpen} onClose={() => setPlanOpen(false)} reason={reason}
        onActive={() => { setPlanOpen(false); run() }} />
    </div>
  )
}

export default StudentAIReviewPanel
